import React, {useState} from "react"
import useRescuers from "hooks/useRescuers"
import Rescuer from "components/Rescuer"
import "./RescuersTable.css"


export default function RescuersTable(params) {

    const {data} = params
    const {getUser} = useRescuers()
    const [sortBy, setSortBy] = useState('lead')
    
    const sortRescuers = (a, b) => {
        let aValue, bValue

        if (sortBy === 'total') {
            aValue = a[1] + a[2]; // lead + member
            bValue = b[1] + b[2]; // lead + member
        } else if (sortBy === 'lead') {
            aValue = a[1]; // lead
            bValue = b[1]; // lead
        } else if (sortBy === 'member') {
            aValue = a[2]; // member
            bValue = b[2]; // member
        }

        // Primary sorting: by the chosen value (descending)
        if (bValue !== aValue) return bValue - aValue
        

        // Secondary sorting: determine the second criterion based on the primary 'by'
        if (sortBy === 'lead' || sortBy === 'total') {
            // If primary is 'lead' or 'total', secondary sort by 'member' (descending)
            if (b[2] !== a[2]) return b[2] - a[2]; // Descending order by member
        } else if (sortBy === 'member') {
            // If primary is 'member', secondary sort by 'lead' (descending)
            if (b[1] !== a[1]) return b[1] - a[1]; // Descending order by lead
        }

        // Tertiary sorting: by username (descending)
        const numA = parseInt(a[0], 10)
        const numB = parseInt(b[0], 10)

        if (!isNaN(numA) && !isNaN(numB)) return numA - numB
        return a[0].localeCompare(b[0])
    }
    
    if (!data) return
    
    return <div id="rescuers">
        <h2>Povrede po spasiocima</h2>
        
        <table id="rescuers">
             <thead>
                 <tr>
                     <th className="index"></th>
                     <th></th>
                     <th className="sort" onClick={() => setSortBy('lead')}>Vođa</th>
                     <th className="sort" onClick={() => setSortBy('member')}>Učesnik</th>
                     <th className="sort" onClick={() => setSortBy('total')}>Ukupno</th>
                </tr>
            </thead>
            <tbody>
                {data.sort(sortRescuers).map(([username, lead, member], idx) => <tr key={username}>
                    <td className="index">{idx+1}.</td>
                    <td className="rescuer"><Rescuer rescuer={getUser(username)} onClick="profile"/></td>
                    <td>{lead}</td>
                    <td>{member}</td>
                    <td>{lead+member}</td>
                </tr>)}
            </tbody>
        </table>
    </div>
    
}